const email = {
    // not fully strict
    // it accepts emails like:
    // .john@email.com
    // john.@email.com
    // john..doe@email.com,
    // which are not acceptable.
    full: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    partial:
        /^$|^[a-zA-Z0-9._%+-]+$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]*$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]*$/,
};

const mobile = {
    full: /^09\d{9}$/,
    partial: /^0?$|^09\d{0,9}$/,
};

const phone = {
    full: /^0\d{4,10}$/,
    partial: /^0?$|^0\d{0,10}$/,
};

const internationalPhoneNumber = {
    full: /^(\+|00|0)[1-9]\d{7,15}$/,
    partial:
        /^$|^\+\d{0,15}$|^0$|^00$|^0[1-9]$|^00[1-9]$|^0[1-9]\d{0,13}$|^00[1-9]\d{0,12}$/,
};

const nationalCode = {
    full: /^\d{10}$/, // more validation needed
    partial: /^\d{0,10}$/,
};

const iranianPassportNumber = {
    full: /^(?=.*[A-Za-z])(?!.*[A-Za-z].*[A-Za-z])(?=(?:.*\d){8,9})[A-Za-z\d]{9,10}$/,
    partial:
        /^(?!(?:.*[A-Za-z]){2})(?!(?=.{10}$)(?!.*[A-Za-z]))[A-Za-z\d]{0,10}$/,
};

const internationalPassportNumber = {
    full: /^[a-zA-Z0-9]{5,12}$/,
    partial: /^[a-zA-Z0-9]{0,12}$/,
};

const EnglishOnly = { full: /^[A-Za-z\s]+$/ };
const PersianOnly = { full: /^[\u0600-\u06FF‌\s]+$/ };
const name = { full: /^[A-Za-z\u0600-\u06FF\s‌]+$/ };
const number = { full: /^\d+$/ };

export default {
    email,
    mobile,
    internationalPhoneNumber,
    nationalCode,
    iranianPassportNumber,
    internationalPassportNumber,
    PersianOnly,
    EnglishOnly,
    name,
    number,
    phone,
};
